import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';
import { get } from 'lodash';

// Actions
export const actions = mapActions([
    'FETCH',
    'FETCH_CAMPAIGNS',
    'FETCH_ZIP_DATA',
    'FETCH_SUCCESS',
    'FETCH_CAMPAIGNS_SUCCESS',
    'FETCH_ZIP_DATA_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'HYPERLOCAL');


// Action Creators
export const fetchHyperLocal = createAction(actions.FETCH, params => params);
export const fetchHyperLocalCampaigns = createAction(actions.FETCH_CAMPAIGNS, params => params);
export const hyperLocalFetched = createAction(actions.FETCH_SUCCESS, data => data);
export const hyperLocalCampaignsFetched = createAction(actions.FETCH_CAMPAIGNS_SUCCESS, data => data);
export const fetchHyperLocalZipData = createAction(actions.FETCH_ZIP_DATA, params => params);
export const hyperLocalZipDataFetched = createAction(actions.FETCH_ZIP_DATA_SUCCESS, data => data);


export const resetHyperLocalInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

const initalDataState = {
    data: null,
    hasData: null // defaulting to null to indicate we are fetching data and don't know if we have data or not.
};

// Reducers
const initialState = {
    ...initalDataState,
    campaigns: null,
    zipData: initalDataState
};

export default handleActions({

    [actions.FETCH_SUCCESS]: (state, action) => {
        const hasData = action.payload.hasData || false;

        if (hasData) {
            const updatedData = {
                data: { $set: action.payload.results },
                hasData: { $set: hasData }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            hasData: { $set: hasData }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_CAMPAIGNS_SUCCESS]: (state, action) => {
        const updatedData = {
            campaigns: { $set: action.payload.results }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_ZIP_DATA_SUCCESS]: (state, action) => {
        const hasData = get(action, 'payload.params.hasData', false);
        if (hasData) {
            const updatedData = {
                data: { $set: action.payload.data },
                hasData: { $set: hasData }
            };
            return update(state, { zipData: updatedData });
        }

        const updatedData = {
            data: { $set: null },
            hasData: { $set: hasData }
        };
        return update(state, { zipData: updatedData });
    },
    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/hyperlocal/duck.js